/**
 * The notification route table.
 *
 * `/notifications` sits at the top level rather than under `/settings`, for the
 * same reason `/attention` does: it is not one module's screen and it is not a
 * configuration surface. `/settings/notification-policies` — which decides how
 * each event is *delivered* — is a separate, administrative screen owned by the
 * attention module, and the two are deliberately not siblings in the nav.
 *
 * Gated on `notification.read`, which every system role holds
 * (`rbac/catalogue_m0.go`): everybody has a bell.
 */

import type { RouteRecordRaw } from 'vue-router'

import { NOTIFICATIONS_PERMISSIONS } from '@/modules/notifications/permissions'

export const NOTIFICATIONS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/modules/notifications/NotificationsInboxView.vue'),
    meta: {
      titleKey: 'notifications.routeTitles.inbox',
      permission: NOTIFICATIONS_PERMISSIONS.read,
    },
  },
]
